/*
  KP: "SELECT YOUR PHONE" ON THE BUNDLE PAGES, made to look and work like the one on the
  phone case product pages (assets/kp-product-picker.js) (13 Oct 2026, Sana). A box showing
  the chosen model; tap it and a panel opens with a search box at the top and the models
  under it, grouped by brand. Type "16 pro", "s24" or "pixel" to narrow the list. On phones
  the list shows first and the keyboard only comes up when you tap the search box, as on
  the product pages.

  The bundle page's own dropdown (made by assets/kp-bundle-pages.js) stays underneath,
  hidden: picking a model sets it, so the bundle works exactly as before. Loaded by
  sections/kp-bundle-builder.liquid; delete that line to undo.
*/
(function () {
  // The same look as the product page picker (assets/kp-product-picker.css, with the black
  // highlight from assets/kp-skin.css).
  var CSS = [
    '.kp-bpm{position:relative}',
    '.kp-bpm [hidden]{display:none!important}',
    '.kp-bpm .kp-bpm__button{display:block;box-sizing:border-box;width:100%;height:42px;min-height:0;margin:0;padding:8px 40px 8px 14px;overflow:hidden;border:1px solid #d9d2ca;border-radius:12px;outline:0;background:#fff url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'8\' viewBox=\'0 0 12 8\' fill=\'none\'%3E%3Cpath d=\'M1.5 1.5 6 6l4.5-4.5\' stroke=\'%23111\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E") no-repeat right 14px center/12px 8px;box-shadow:none;color:#000;font-family:inherit;font-size:13px;font-weight:400;letter-spacing:normal;line-height:1.6;text-align:left;text-overflow:ellipsis;text-transform:none;white-space:nowrap;cursor:pointer;-webkit-appearance:none;appearance:none}',
    '.kp-bpm .kp-bpm__button.is-empty{color:#6f675f}',
    '.kp-bpm .kp-bpm__button:focus-visible,.kp-bpm .kp-bpm__button[aria-expanded="true"]{border-color:#111;box-shadow:0 0 0 1px #111}',
    '.kp-bpm__panel{position:absolute;top:calc(100% + 6px);left:0;z-index:30;display:flex;flex-direction:column;box-sizing:border-box;width:100%;max-height:min(380px,56vh);overflow:hidden;border:1px solid #d9d2ca;border-radius:14px;background:#fff;box-shadow:0 14px 36px rgba(40,25,10,.16);text-align:left}',
    '.kp-bpm__search{flex:0 0 auto;border-bottom:1px solid #efe9e2}',
    '.kp-bpm .kp-bpm__search-input{display:block;box-sizing:border-box;width:100%;height:44px;margin:0;padding:0 14px;border:0;border-radius:0;outline:0;background:#fff;box-shadow:none;color:#111;font-family:inherit;font-size:16px;-webkit-appearance:none;appearance:none}',
    '.kp-bpm__list{position:relative;flex:1 1 auto;padding:4px 0 8px;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch}',
    '.kp-bpm__group{padding:12px 14px 4px;color:#8a7f76;font-size:11px;font-weight:600;letter-spacing:.08em;text-transform:uppercase}',
    '.kp-bpm .kp-bpm__option{display:block;width:100%;min-height:0;margin:0;padding:9px 14px;border:0;border-radius:0;background:transparent;box-shadow:none;color:#111;font-family:inherit;font-size:14px;font-weight:400;letter-spacing:normal;line-height:1.25;text-align:left;text-transform:none;cursor:pointer}',
    '.kp-bpm .kp-bpm__option:hover,.kp-bpm .kp-bpm__option.is-active{background:#faf4ee}',
    '.kp-bpm .kp-bpm__option[aria-selected="true"]{font-weight:600}',
    '.kp-bpm__empty{padding:14px;color:#7a7a7a;font-size:14px}'
  ].join('');
  var EMPTY = 'Select your phone model';
  var openBox = null;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function closePanel(focusButton) {
    if (!openBox) return;
    var box = openBox;
    openBox = null;
    box.panel.hidden = true;
    box.button.setAttribute('aria-expanded', 'false');
    if (focusButton) box.button.focus();
  }

  function enhance(select) {
    if (select.getAttribute('data-kp-bpm')) return;
    select.setAttribute('data-kp-bpm', '1');

    // The brands and models, read from the bundle page's own dropdown.
    var groups = [];
    Array.prototype.forEach.call(select.querySelectorAll('optgroup'), function (og) {
      var names = [];
      Array.prototype.forEach.call(og.querySelectorAll('option'), function (o) { names.push(o.value); });
      groups.push({ label: og.label, names: names });
    });

    var wrap = el('div', 'kp-bpm');
    var button = el('button', 'kp-bpm__button');
    button.type = 'button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', 'Select your phone model');

    var panel = el('div', 'kp-bpm__panel');
    panel.hidden = true;
    var searchBox = el('div', 'kp-bpm__search');
    var search = el('input', 'kp-bpm__search-input');
    search.type = 'search';
    search.placeholder = 'Search';
    search.setAttribute('aria-label', 'Search phone models');
    search.setAttribute('autocomplete', 'off');
    search.setAttribute('autocorrect', 'off');
    search.setAttribute('autocapitalize', 'off');
    search.setAttribute('spellcheck', 'false');
    searchBox.appendChild(search);
    var list = el('div', 'kp-bpm__list');
    list.setAttribute('role', 'listbox');
    panel.appendChild(searchBox);
    panel.appendChild(list);
    wrap.appendChild(button);
    wrap.appendChild(panel);

    var box = { wrap: wrap, button: button, panel: panel, list: list, active: -1 };

    function showCurrent() {
      button.textContent = select.value || EMPTY;
      button.classList.toggle('is-empty', !select.value);
    }

    function picks() { return Array.prototype.slice.call(list.querySelectorAll('.kp-bpm__option')); }

    function mark(i) {
      var all = picks();
      if (!all.length) { box.active = -1; return; }
      box.active = Math.max(0, Math.min(i, all.length - 1));
      all.forEach(function (b, n) { b.classList.toggle('is-active', n === box.active); });
      var a = all[box.active];
      if (a.offsetTop < list.scrollTop) list.scrollTop = a.offsetTop - 8;
      else if (a.offsetTop + a.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = a.offsetTop + a.offsetHeight - list.clientHeight + 8;
    }

    function draw(query) {
      var typed = (query || '').trim().toLowerCase();
      var words = typed.split(/\s+/).filter(Boolean);
      var count = 0;
      var exact = -1;
      list.innerHTML = '';
      groups.forEach(function (g) {
        var head = false;
        g.names.forEach(function (name) {
          var hay = (name + ' ' + g.label).toLowerCase();
          if (!words.every(function (w) { return hay.indexOf(w) > -1; })) return;
          if (!head) { list.appendChild(el('div', 'kp-bpm__group', g.label)); head = true; }
          var b = el('button', 'kp-bpm__option', name);
          b.type = 'button';
          b.setAttribute('role', 'option');
          b.setAttribute('data-value', name);
          b.setAttribute('aria-selected', name === select.value ? 'true' : 'false');
          list.appendChild(b);
          // "iphone 17 pro" lands on iPhone 17 Pro, not iPhone 17 Pro Max above it.
          if (name.toLowerCase() === typed) exact = count;
          count++;
        });
      });
      if (!count) list.appendChild(el('div', 'kp-bpm__empty', 'Nothing found'));
      box.active = -1;
      list.scrollTop = 0;
      if (words.length && count) mark(exact > -1 ? exact : 0);
    }

    function open() {
      closePanel(false);
      openBox = box;
      panel.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      search.value = '';
      draw('');
      var chosen = list.querySelector('[aria-selected="true"]');
      if (chosen) list.scrollTop = Math.max(0, chosen.offsetTop - 60);
      // Only jump to the search box where there is a real keyboard, so phones show the list first.
      if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) search.focus();
    }

    function choose(name) {
      closePanel(true);
      if (name === select.value) return;
      select.value = name;
      showCurrent();
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    button.addEventListener('click', function () {
      if (openBox === box) closePanel(false);
      else open();
    });
    list.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.kp-bpm__option') : null;
      if (b) choose(b.getAttribute('data-value'));
    });
    search.addEventListener('input', function () { draw(search.value); });
    search.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); mark(box.active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); mark(box.active - 1); }
      else if (e.key === 'Enter') {
        e.preventDefault();
        var all = picks();
        var b = all[box.active > -1 ? box.active : 0];
        if (b) choose(b.getAttribute('data-value'));
      }
    });
    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openBox === box) { e.stopPropagation(); closePanel(true); }
    });

    // "Add to cart" with no model chosen points at the dropdown: send it to the box instead.
    select.focus = function () { button.focus(); open(); };
    select.scrollIntoView = function (o) { button.scrollIntoView(o); };

    showCurrent();
    select.hidden = true;
    select.style.display = 'none';
    select.parentNode.insertBefore(wrap, select.nextSibling);
  }

  function scan() {
    // The bundle box redraws itself as you choose: if the open panel went with it, forget it.
    if (openBox && !document.documentElement.contains(openBox.wrap)) openBox = null;
    Array.prototype.forEach.call(document.querySelectorAll('[data-kp-bundle-builder] select[data-kp-bb-model]'), enhance);
  }

  function start() {
    var style = el('style');
    style.textContent = CSS;
    document.head.appendChild(style);
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
    // A tap anywhere else closes the panel.
    document.addEventListener('pointerdown', function (e) {
      if (openBox && !openBox.wrap.contains(e.target)) closePanel(false);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
